import makeStyles from '@mui/styles/makeStyles';
import {
	ACCENT_COLOR,
	FONT_COLOR,
	FONT_COLOR_TERTIARY,
	TERTIARY_COLOR,
} from 'utils/constants';

export const useStyles = makeStyles({
	title: {
		color: FONT_COLOR_TERTIARY,
		cursor: 'pointer',
		transition: '0.3s',
	},
	activeTitle: {
		color: FONT_COLOR,
		cursor: 'default',
	},
	preserveLeftThumbColor: {
		'& .MuiSwitch-switchBase.Mui-disabled .MuiSwitch-thumb': {
			color: '#b3b3b3',
		},
	},
	preserveRightThumbColor: {
		'& .MuiSwitch-switchBase.Mui-disabled .MuiSwitch-thumb': {
			color: TERTIARY_COLOR,
		},
	},
});
